import { render, staticRenderFns } from "./winding.vue?vue&type=template&id=0c7879ee&"
import script from "./winding.vue?vue&type=script&lang=js&"
export * from "./winding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports